module.exports = __webpack_public_path__ + "img/img_target_top_bf.e802ed9a.svg";